export default __webpack_public_path__ + "static/timberline-education-small-1c8e6f81e937fe1fa02f1d397994bd4e.jpg";